<template>
  <v-breadcrumbs v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-breadcrumbs>
</template>

<script>
export default {
    name: "ABreadcrumbs",
}
</script>

<style scoped>
/* ::v-deep .v-breadcrumbs {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    flex: 0 1 auto;
    list-style-type: none;
    margin: 0;
    padding: 0, 0, 8px !important;
} */
.disabled-text {
    color: var(--v-darkCharcoal-base) !important;
}
.v-application ul, .v-application ol {
    padding-left: 0 !important;
    padding-bottom: 8px !important;
}
::v-deep .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
    color: var(--v-darkCharcoal-base) !important;
}
</style>